<template>
    <div class="a">
        <top></top>
        <navs></navs>
        <div class="content">
            <div class="time">
                <div class="cont">
                    <div class="cont_a">
                        
                        <div class="p"># {{ obj.name }}</div>
                        <div v-html="obj.briefInfo"></div>
                    </div>
                    <div class="cont_b">
                        <div class="cont_zd" v-for="(item,index) in list" :key="index" @click="album(item.id)">
                            <div class="image">
                                <img :src="item.placard" alt="" width="158px" height="158px">
                            </div>
                            <div class="cont_title">
                                <h4>专辑名称：{{ item.name }}</h4>
                                <!-- <h4>视频数量：{{ item.totalSize }}</h4> -->
                                <div class="cont_text"><h4>描述文字：</h4><span style=" color: #333333;
 font-size: .15rem;">{{ item.briefInfo }}</span></div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import axios from "axios"
export default {
    components: {
        top,
        bottom,
        navs
    },
    data(){
        return{
            list:[],
            obj:{}
        }
    },
    created(){
        axios({
            method:"GET",
            url:"https://www.jnccljh.com/api/tags/"+this.$route.query.id
        }).then(res=>{
            console.log(res)
            // this.tlist = res.data.data
            this.obj = res.data.data
        })
        axios({
            method:"GET",
            url:"https://www.jnccljh.com/api/tags/"+this.$route.query.id+"/records"
        }).then(res=>{
            console.log(res)
            this.list = res.data.data
        })
    },
    methods:{
        album(item){
            this.$router.push({path:"/adetail",query:{id:item,name:this.obj.name}})
        }
    }
}
</script>
<style scoped>
.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
}
.content{
    width: 100%;
    /* height: 480px; */
    /* height: 1330px; */
    background-image: url(../image/back.png);
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
}
.time{
    width: 70%;
    margin: 0 auto;
    /* height: 1330px; */
    /* background-color: #F7F7F7; */
    display: flex;
    flex-direction: column;
    align-items: center;
}
.bule{
    width: 5px;
height: 16px;
background: #1463FF;
}
.p{
    margin-left: 5px;
    font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 17px;
color: #1463FF;
line-height: 17px;
font-style: normal;
margin-bottom: 10px;
}
.cont{
    width: 100%;
    margin: 0 auto;
}
.cont_b{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.cont_zd{
    width: 48%;
    height: 190px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
  
    margin-bottom: 20px;
}
.cont_zd:hover{
    width: 48%;
    height: 190px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    color: #1463FF;
    margin-bottom: 20px;
}
.image{
    width: 190px;
    height: 190px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cont_a{
    height: 74px;
    display: flex;
    /* align-items: center; */
    flex-direction: column;
    margin-top: 24px;
}
.cont_title{
    width: 60%;
    height: 158px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}
.cont_text{
    display: flex;
    overflow: hidden;
 text-overflow: ellipsis;
 display: -webkit-box;
 -webkit-line-clamp: 6;
 -webkit-box-orient: vertical;

}
</style>


// WEBPACK FOOTER //
// src/views/album.vue